import {
  MindCatalogGroup,
  MindCatalogItem,
  MindCatalogResponse,
} from '../../models/mind-catalog.model';
import { sanitizeSlug } from '../../utils/utils';

export function sortMindCatalogItems(
  items: MindCatalogItem[] | null | undefined
): MindCatalogItem[] {
  return [...(items ?? [])].sort(
    (a, b) => (a.sortOrder ?? 999) - (b.sortOrder ?? 999)
  );
}

export function findMindCatalogProductIndex(
  items: MindCatalogItem[] | null | undefined,
  productId: string | number
): number {
  const id = String(productId);
  return sortMindCatalogItems(items).findIndex(
    item => String(item.purchasePayload?.product?.id) === id
  );
}

export function resolveMindCatalogGroup(
  catalog: MindCatalogResponse | null,
  currentCategory: string,
  currentProductUuid: string
): MindCatalogGroup | undefined {
  const groups = catalog?.groups ?? [];
  if (!groups.length) {
    return undefined;
  }

  let g = groups.find(gr => gr.title === currentCategory);
  if (g) {
    return g;
  }

  const catSlug = sanitizeSlug(currentCategory);
  g = groups.find(gr => sanitizeSlug(gr.title) === catSlug);
  if (g) {
    return g;
  }

  if (currentProductUuid) {
    return groups.find(gr =>
      gr.items.some(
        i => String(i.purchasePayload?.product?.id) === currentProductUuid
      )
    );
  }

  return undefined;
}
